export const brandedOAuthLogos = {
    GOOGLE: 'googleBrand',
    TWITTER: 'twitter',
    APPLE: 'apple',
    DISCORD: 'discordBrand',
    FACEBOOK: 'facebookBrand',
    FARCASTER: 'farcasterBrand',
};
export const oAuthLogos = {
    GOOGLE: 'google',
    TWITTER: 'twitter',
    APPLE: 'apple',
    DISCORD: 'discord',
    FACEBOOK: 'facebook',
    FARCASTER: 'farcaster',
};
